import Glide from '@glidejs/glide';

class sliderHeroHelper {

    constructor() {}


    initSlider(el) {
        new Glide(el, {
            type: 'carousel',
            focusAt: 'center',
            rewind: true,
            autoplay: false,
            gap: 40,
            animationDuration: 600,
            peek: 200,
            breakpoints: {
                1199: {
                    gap: 40,
                    peek: 200,
                },
                991: {
                    gap: 40,
                    peek: 100,
                },
                767: {
                    gap: 40,
                    peek: 50,
                },
                575: {
                    gap: 30,
                    peek: 0,
                },
            }
        }).mount();
    }
}

window.app.add('sliderHero', new sliderHeroHelper());